export function set(array) {
    const newSet = {};
    array?.forEach((elem) => {
        newSet[`${elem}`] = true;
    });
    return newSet;
}
export function keyMap(array, key) {
    const map = {};
    array?.forEach((elem) => {
        map[`${elem[key]}`] = elem;
    });
    return map;
}
export function addToIdSet(array, idSet) {
    array?.forEach((elem) => {
        idSet[`${elem}`] = elem;
    });
    return idSet;
}
export function isUnique(array, predicate) {
    const elements = new Set();
    for (const element of array) {
        const key = predicate(element);
        if (elements.has(key)) {
            return false;
        }
        elements.add(key);
    }
    return true;
}
//# sourceMappingURL=universal_array_helper.js.map